/**
 * Runtime configuration for the public Room.
 *
 * `VITE_API_BASE` is inlined at BUILD time (vite.config.ts fails the build when it is missing), so a
 * staging bundle can never talk to the prod API — the environments are separated by artefact, not by
 * a runtime switch someone can get wrong.
 */
export const config = {
  apiBase: import.meta.env.VITE_API_BASE as string,
  /** Where the professional's dashboard lives. Only used for support copy, never linked into. */
  productName: 'Claro',
} as const;

/**
 * The instance id arrives in the URL FRAGMENT (`#i=<id>`), never the query string.
 *
 * Fragments are not sent to the server in the HTTP request line, so the id stays out of access logs,
 * out of `Referer` headers on any outbound link, and out of most analytics — meaningful because this
 * id is what addresses a client's onboarding. It is not a secret (the OTP is the gate), but there is
 * no reason to spray it across every intermediary either.
 *
 * Deliberately NOT `takeFragmentToken()` from @huaca/ui: that helper reads a different key and is
 * part of the session-coupled barrel this app must never import.
 */
export function readInstanceIdFromUrl(hash: string = window.location.hash): string | null {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  const id = new URLSearchParams(raw).get('i');
  return id && id.trim() ? id.trim() : null;
}
